var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (fair) {
buf.push("<div class=\"abrv-context__content abrv-context__content--fair\"><img" + (jade.attr("src", fair.profile.icon.url, true, true)) + "><div class=\"abrv-context__content--fair__info\"><div>" + (jade.escape(null == (jade_interp = fair.name) ? "" : jade_interp)) + "</div><div>" + (jade.escape((jade_interp = fair.location.city) == null ? '' : jade_interp)) + ", " + (jade.escape((jade_interp = fair.start_at) == null ? '' : jade_interp)) + " – " + (jade.escape((jade_interp = fair.end_at) == null ? '' : jade_interp)) + "</div><br>");
if ( fair.tagline)
{
buf.push("<div>" + (jade.escape(null == (jade_interp = fair.tagline) ? "" : jade_interp)) + "</div>");
}
buf.push("</div></div>");}.call(this,"fair" in locals_for_with?locals_for_with.fair:typeof fair!=="undefined"?fair:undefined));;return buf.join("");
};
module.exports = template;